'use client';
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import AuthBrandPanel from './AuthBrandPanel';

export default function AuthPageClient() {
  const [tab, setTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen bg-background flex">
      {/* Left brand panel */}
      <AuthBrandPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 py-12 lg:px-12 min-h-screen">
        <div className="w-full max-w-md animate-fade-in">
          {/* Logo mobile */}
          <div className="flex items-center gap-2 mb-8 lg:hidden">
            <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <polygon points="10,2 18,7 18,13 10,18 2,13 2,7" fill="white" opacity="0.9" />
                <path d="M10 6 L10 14 M7 10 L13 10" stroke="#0EA5E9" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <span className="font-extrabold text-xl tracking-tight text-foreground">CryptoFaucet</span>
          </div>

          {/* Tab switcher */}
          <div className="flex bg-secondary rounded-2xl p-1 mb-8 gap-1">
            <button
              onClick={() => setTab('login')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                tab === 'login' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setTab('signup')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                tab === 'signup' ?'bg-card text-foreground shadow-sm' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Form */}
          <div className="animate-slide-up">
            {tab === 'login' ? (
              <LoginForm />
            ) : (
              <SignupForm onSuccess={() => setTab('login')} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}